import React, { useState } from "react";
import { ChevronDownIcon, ChevronUpIcon, TableCellsIcon } from "@heroicons/react/24/solid";
import OrdersTablePreview from "./OrdersTablePreview";
import { Link } from "react-router-dom";

export default function AdminDashboardOrdersTable() {
  const [showContent, setShowContent] = useState(true);

  function handleToggle() {
    setShowContent(!showContent);
  }

  const containerStyles = "mb-[30px] bg-white rounded-xl shadow-md blur-2 text-opacity-15 spread-0";
  const buttonStyles = `w-full flex items-stretch justify-between py-4 px-6 ${showContent ? "border-b border-b-gray-300" : ""}`;

  return (
    <div className={containerStyles}>
      <button className={buttonStyles} onClick={handleToggle}>
        <header className="flex items-center flex-1">
          <div className="bg-blue-600 rounded-lg p-1 flex items-center justify-center h-[25px] w-[25px] mr-2">
            <TableCellsIcon className="h-3 w-3 text-white" />
          </div>
          <h3 className="text-lg font-semibold">Orders</h3>
        </header>
        <footer className="flex items-center ">
          {showContent ? <ChevronUpIcon className="block h-4 w-4" /> : <ChevronDownIcon className="block h-4 w-4" />}
        </footer>
      </button>
      {showContent ? (
        <section className="p-6">
          <section className="mb-6">
            <OrdersTablePreview />
          </section>
          <footer className="flex items-center justify-center my-2">
            <Link
              to="orders"
              className="block text-white bg-blue-700 hover:bg-blue-800 focus:outline-none focus:ring-4 focus:ring-blue-300 font-medium rounded-full text-sm px-5 py-2 text-center mr-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
            >
              View all orders
            </Link>
          </footer>
        </section>
      ) : null}
    </div>
  );
}
